/**
 * sh-header.js — 新ヘッダーのSPドロワー + ヘッダー計測 (CHG-086 / DEV-HERO)
 *
 * - ドロワー: aria-expanded / フォーカストラップ (global.js の trapFocus 流用) / Esc で閉じる。
 *   Dawn の header-drawer / menu-drawer カスタム要素は使わない (.header-wrapper 依存があるため)。
 * - 計測: shogun_header_cart_click を Shopify.analytics.publish で発火。
 *   GA4 への転送はカスタムピクセル側の購読が前提 (req-dev-hero.md A-1-6・DEV-B 連携)。
 */
(function () {
  'use strict';

  function publish(name, data) {
    if (
      typeof window.Shopify === 'object' &&
      window.Shopify !== null &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(name, data);
      } catch (e) {
        /* 計測で落とさない */
      }
    }
  }

  /* カーンFB 2026-08-30: stickyクロームの実高を CSS 変数へ実測セットする。
   * --sh-offerbar-h: オファーバー実高 (×で閉じたら0) → ヘッダーの sticky top
   * --sh-chrome-h:   バー+ヘッダー合計 → SPドロワーの開始位置・アンカー着地補正 */
  function setChromeVars() {
    var root = document.documentElement;
    var bar = document.querySelector('.shogun-offer-bar-section');
    var headerSec = document.querySelector('.sh-header-section');
    var barH = bar && !bar.hidden ? bar.offsetHeight : 0;
    var headH = headerSec ? headerSec.offsetHeight : 0;
    root.style.setProperty('--sh-offerbar-h', barH + 'px');
    root.style.setProperty('--sh-chrome-h', barH + headH + 'px');
  }

  function init() {
    setChromeVars();
    window.addEventListener('resize', setChromeVars, { passive: true });
    window.addEventListener('load', setChromeVars);
    document.addEventListener('shogun:chrome-change', setChromeVars);

    var burger = document.querySelector('.sh-header__burger');
    var drawer = document.getElementById('sh-drawer');

    if (burger && drawer) {
      var onKey = function (event) {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') close(true);
      };

      var open = function () {
        drawer.hidden = false;
        burger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('sh-drawer-open');
        if (typeof trapFocus === 'function') {
          // トラップはヘッダーセクション全体 (閉じるトグル=バーガーにもキーボード到達できるように)
          var trapRoot = burger.closest('.shopify-section') || drawer;
          trapFocus(trapRoot, drawer.querySelector('a'));
        }
        document.addEventListener('keyup', onKey);
      };

      var close = function (focusBurger) {
        drawer.hidden = true;
        burger.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('sh-drawer-open');
        if (typeof removeTrapFocus === 'function') {
          removeTrapFocus(focusBurger ? burger : null);
        }
        document.removeEventListener('keyup', onKey);
      };

      burger.addEventListener('click', function () {
        if (drawer.hidden) {
          open();
        } else {
          close(true);
        }
      });

      drawer.addEventListener('click', function (event) {
        if (event.target && event.target.closest && event.target.closest('a')) close(false);
      });
    }

    var cart = document.getElementById('cart-icon-bubble');
    if (cart) {
      cart.addEventListener('click', function () {
        var count = 0;
        var bubble = cart.querySelector('.cart-count-bubble span[aria-hidden]');
        if (bubble) count = parseInt(bubble.textContent, 10) || 0;
        publish('shogun_header_cart_click', { cart_count: count });
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
